import React from 'react';
import { Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white" data-id="element-151" data-mp="3ggtx2ezk5d3n">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-152" data-mp="32o4deh7i4k9p">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-153" data-mp="32lrm3dfusxjz">
          <div className="md:col-span-1" data-id="element-154" data-mp="36q92d2n08sq0">
            <h2 className="text-2xl font-bold text-indigo-400 mb-4" data-id="element-155" data-mp="36n3axgqwler4">Turnout</h2>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-156" data-mp="3uftkjjbc3ly8">
              Turn events into a forecastable revenue channel. 5x on event
              spend, 30 minutes a week.
            </p>
            <div className="flex space-x-4" data-id="element-157" data-mp="3le2jirrqo3ap">
              <a href="https://x.com/turnout_info" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-158" data-mp="3qd6u9muba935">
                <Twitter size={20} data-id="element-159" data-mp="2ez1ja9vokyyb" />
              </a>
              <a href="https://www.linkedin.com/company/turnout-info" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-160" data-mp="3l9adtjp9964y">
                <Linkedin size={20} data-id="element-161" data-mp="3v9az3b6opwbs" />
              </a>
            </div>
          </div>
          <div data-id="element-162" data-mp="3q7u1ppnesrzy">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-163" data-mp="3q7bvq1ay2zeu">Features</h3>
            <ul className="space-y-3" data-id="element-164" data-mp="81pgvn5hf5bh">
              <li data-id="element-165" data-mp="80nrednpyga8">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-166" data-mp="3473nkkfm3xo">
                  Event Sourcing
                </a>
              </li>
              <li data-id="element-167" data-mp="ctgxp5yu5wof">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-168" data-mp="cv1qor5i57k6">
                  ICP Calibration
                </a>
              </li>
              <li data-id="element-169" data-mp="mptpfyatm0gj">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-170" data-mp="tv4mo01f303y">
                  ROI Worksheet
                </a>
              </li>
              <li data-id="element-171" data-mp="13sr1ynmmotog">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-172" data-mp="13s99m2336zlt">
                  Invite Management
                </a>
              </li>
              <li data-id="element-173" data-mp="1clcjy1ifqwc8">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-174" data-mp="1cnyqbxtlb5sv">
                  No-Show Protection
                </a>
              </li>
              <li data-id="element-175" data-mp="1rilipga2j2dz">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-176" data-mp="1rhtuwrmpq8y9">
                  Attributable Meetings
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-177" data-mp="2af3r7lrdkvhi">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-178" data-mp="2aevhg2qju6aj">Company</h3>
            <ul className="space-y-3" data-id="element-179" data-mp="2agyaywqwuhk0">
              <li data-id="element-180" data-mp="25o5c2pi4i3fu">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-181" data-mp="25mu5yj17gjlk">
                  About Us
                </a>
              </li>
              <li data-id="element-182" data-mp="1wpjt4t8qomej">
                <a href="#case-studies" className="text-gray-400 hover:text-white transition-colors" data-id="element-183" data-mp="1wlw0rxf1661e">
                  Case Studies
                </a>
              </li>
              <li data-id="element-184" data-mp="2kcrzlehwm1i5">
                <a href="#testimonials" className="text-gray-400 hover:text-white transition-colors" data-id="element-185" data-mp="2kc8g3tclv520">
                  Testimonials
                </a>
              </li>
              <li data-id="element-186" data-mp="18zpi8h7zd7wx">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-187" data-mp="18w1obgymijho">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-188" data-mp="2wmpq0l7r1ylr">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-189" data-mp="2wn99w7gymx2f">Legal</h3>
            <ul className="space-y-3" data-id="element-190" data-mp="2ivkvfxj8nwia">
              <li data-id="element-191" data-mp="2iwm7o5bzqp1l">
                <a href="https://docs.google.com/document/d/1HAZaZGu4ejcYphouQQGkXGUJd2il_LeQ6eTjj86GCQE/edit?usp=drive_web&ouid=107501030604000419011" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-192" data-mp="2it86v1iz6nw9">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-193" data-mp="36kncb361tlbq">
                <a href="https://docs.google.com/document/d/1SB9umObVrSOeRQ980QkfM6CooUfdz4gMGKM_DGYPego/edit?tab=t.0" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-194" data-mp="36k43qd2ag9ad">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-gray-800 text-center text-gray-500" data-id="element-195" data-mp="1im368j3o5pht">
          <p data-id="element-196" data-mp="1wlktuv58awpl">&copy; {currentYear} Turnout. All rights reserved.</p>
          <p className="mt-2 text-sm" data-id="element-197" data-mp="1rnsw3khwkgdh">Academi Technologies Inc.</p>
        </div>
      </div>
    </footer>;
}